// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bottom-left language shortcut — brand-aware, above the floating nav */

.lang-shortcut {
  position: fixed;
  left: max(12px, env(safe-area-inset-left, 0px));
  bottom: max(16px, env(safe-area-inset-bottom, 0px));
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  pointer-events: none;
}

html.app-bottom-nav-shell .lang-shortcut {
  bottom: calc(92px + env(safe-area-inset-bottom, 0px));
}

html.digiping-chat-open .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite),
html.lt-immersive .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite),
html.lt-route-active .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite) {
  display: none;
}

.lang-shortcut__btn,
.lang-shortcut__panel,
.lang-shortcut__option {
  pointer-events: auto;
}

.lang-shortcut__btn {
  width: 52px;
  height: 52px;
  padding: 0;
  border-radius: 16px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 38%, transparent);
  background: var(--glass-bg, color-mix(in srgb, var(--surface-color, #111827) 82%, transparent));
  color: var(--text-color, #f9fafb);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow:
    0 8px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),
    0 2px 8px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  transition:
    transform 0.4s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.3s ease,
    background-color 0.3s ease,
    border-color 0.3s ease;
  -webkit-tap-highlight-color: transparent;
}

.lang-shortcut__btn:hover {
  transform: scale(1.04);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 58%, transparent);
  box-shadow:
    0 10px 28px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent),
    0 2px 8px rgba(0, 0, 0, 0.1);
}

.lang-shortcut__btn:active {
  transform: scale(0.97);
}

.lang-shortcut__btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

.lang-shortcut__btn.is-open {
  background: var(--brand-primary, #0877bc);
  border-color: var(--brand-primary, #0877bc);
  color: #fff;
}

.lang-shortcut__btn-flag {
  font-size: 20px;
  line-height: 1;
}

.lang-shortcut__btn-code {
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.1;
  margin-top: 1px;
}

.lang-shortcut__panel {
  min-width: 220px;
  max-width: min(280px, calc(100vw - 24px));
  padding: 6px;
  border-radius: 16px;
  background: var(--glass-bg, rgba(17, 24, 39, 0.92));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);
  animation: lang-shortcut-in 0.22s cubic-bezier(0.25, 1, 0.5, 1);
}

.lang-shortcut__option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--text-color, #f9fafb);
  cursor: pointer;
  text-align: left;
  min-height: 44px;
  transition: background-color 0.2s cubic-bezier(0.25, 1, 0.5, 1);
  -webkit-tap-highlight-color: transparent;
}

.lang-shortcut__option:hover,
.lang-shortcut__option:focus-visible {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);
}

.lang-shortcut__option:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: -2px;
}

.lang-shortcut__option.is-selected {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);
}

.lang-shortcut__option.is-pending {
  opacity: 0.75;
}

.lang-shortcut__option:disabled {
  cursor: wait;
}

.lang-shortcut__flag {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 16px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);
}

.lang-shortcut__meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.lang-shortcut__name {
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.lang-shortcut__code {
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary, var(--brand-text-secondary, #838383));
}

.lang-shortcut__check {
  color: var(--brand-primary, #0877bc);
  font-weight: 700;
  font-size: 14px;
}

@keyframes lang-shortcut-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Compact language control for admin/coach dashboard top bar */
.lang-shortcut--inline {
  position: relative;
  left: auto;
  bottom: auto;
  z-index: 5;
  align-items: flex-end;
  pointer-events: auto;
}

.lang-shortcut--inline .lang-shortcut__btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  box-shadow: none;
}

.lang-shortcut--inline .lang-shortcut__btn-flag {
  font-size: 16px;
}

.lang-shortcut--inline .lang-shortcut__btn-code {
  font-size: 8px;
}

.lang-shortcut--inline .lang-shortcut__panel {
  position: absolute;
  right: 0;
  bottom: auto;
  top: calc(100% + 8px);
  min-width: 200px;
  animation: lang-shortcut-inline-in 0.18s cubic-bezier(0.25, 1, 0.5, 1);
}

@keyframes lang-shortcut-inline-in {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Compact language control beside invite "Join {club}" banner */
.lang-shortcut--invite {
  align-items: flex-end;
  flex-shrink: 0;
}

.lang-shortcut--invite .lang-shortcut__btn {
  width: auto;
  min-width: 44px;
  height: 32px;
  padding: 0 0.55rem 0 0.4rem;
  flex-direction: row;
  gap: 0.28rem;
  border-radius: 999px;
  box-shadow: none;
}

.lang-shortcut--invite .lang-shortcut__btn-flag {
  font-size: 14px;
}

.lang-shortcut--invite .lang-shortcut__btn-code {
  font-size: 10px;
  margin-top: 0;
  letter-spacing: 0.04em;
}

/* Open toward the left so the menu stays on-screen when the control is top-right */
.lang-shortcut--invite .lang-shortcut__panel {
  left: auto;
  right: 0;
  min-width: 200px;
  max-width: min(280px, calc(100vw - 1.5rem));
}

@media (prefers-reduced-motion: reduce) {
  .lang-shortcut__btn,
  .lang-shortcut__option,
  .lang-shortcut__panel {
    animation: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageShortcutFab.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,eAAe;EACf,+CAA+C;EAC/C,mDAAmD;EACnD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oFAAoF;EACpF,+FAA+F;EAC/F,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC;;iCAE+B;EAC/B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN;;;;0BAIwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,gFAAgF;EAChF;;gCAE8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,2BAA2B;EAC3B,mCAAmC;EACnC,oFAAoF;EACpF,2CAA2C;EAC3C,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+DAA+D;EAC/D,wCAAwC;AAC1C;;AAEA;;EAEE,8EAA8E;AAChF;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE;;;IAGE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Bottom-left language shortcut — brand-aware, above the floating nav */\n\n.lang-shortcut {\n  position: fixed;\n  left: max(12px, env(safe-area-inset-left, 0px));\n  bottom: max(16px, env(safe-area-inset-bottom, 0px));\n  z-index: 1200;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  pointer-events: none;\n}\n\nhtml.app-bottom-nav-shell .lang-shortcut {\n  bottom: calc(92px + env(safe-area-inset-bottom, 0px));\n}\n\nhtml.digiping-chat-open .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite),\nhtml.lt-immersive .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite),\nhtml.lt-route-active .lang-shortcut:not(.lang-shortcut--inline):not(.lang-shortcut--invite) {\n  display: none;\n}\n\n.lang-shortcut__btn,\n.lang-shortcut__panel,\n.lang-shortcut__option {\n  pointer-events: auto;\n}\n\n.lang-shortcut__btn {\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  border-radius: 16px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 38%, transparent);\n  background: var(--glass-bg, color-mix(in srgb, var(--surface-color, #111827) 82%, transparent));\n  color: var(--text-color, #f9fafb);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow:\n    0 8px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),\n    0 2px 8px rgba(0, 0, 0, 0.18);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  transition:\n    transform 0.4s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.3s ease,\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.lang-shortcut__btn:hover {\n  transform: scale(1.04);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 58%, transparent);\n  box-shadow:\n    0 10px 28px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent),\n    0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.lang-shortcut__btn:active {\n  transform: scale(0.97);\n}\n\n.lang-shortcut__btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n.lang-shortcut__btn.is-open {\n  background: var(--brand-primary, #0877bc);\n  border-color: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.lang-shortcut__btn-flag {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.lang-shortcut__btn-code {\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  line-height: 1.1;\n  margin-top: 1px;\n}\n\n.lang-shortcut__panel {\n  min-width: 220px;\n  max-width: min(280px, calc(100vw - 24px));\n  padding: 6px;\n  border-radius: 16px;\n  background: var(--glass-bg, rgba(17, 24, 39, 0.92));\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);\n  animation: lang-shortcut-in 0.22s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.lang-shortcut__option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin: 0;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--text-color, #f9fafb);\n  cursor: pointer;\n  text-align: left;\n  min-height: 44px;\n  transition: background-color 0.2s cubic-bezier(0.25, 1, 0.5, 1);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.lang-shortcut__option:hover,\n.lang-shortcut__option:focus-visible {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);\n}\n\n.lang-shortcut__option:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: -2px;\n}\n\n.lang-shortcut__option.is-selected {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);\n}\n\n.lang-shortcut__option.is-pending {\n  opacity: 0.75;\n}\n\n.lang-shortcut__option:disabled {\n  cursor: wait;\n}\n\n.lang-shortcut__flag {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 16px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);\n}\n\n.lang-shortcut__meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.lang-shortcut__name {\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.lang-shortcut__code {\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary, var(--brand-text-secondary, #838383));\n}\n\n.lang-shortcut__check {\n  color: var(--brand-primary, #0877bc);\n  font-weight: 700;\n  font-size: 14px;\n}\n\n@keyframes lang-shortcut-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Compact language control for admin/coach dashboard top bar */\n.lang-shortcut--inline {\n  position: relative;\n  left: auto;\n  bottom: auto;\n  z-index: 5;\n  align-items: flex-end;\n  pointer-events: auto;\n}\n\n.lang-shortcut--inline .lang-shortcut__btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  box-shadow: none;\n}\n\n.lang-shortcut--inline .lang-shortcut__btn-flag {\n  font-size: 16px;\n}\n\n.lang-shortcut--inline .lang-shortcut__btn-code {\n  font-size: 8px;\n}\n\n.lang-shortcut--inline .lang-shortcut__panel {\n  position: absolute;\n  right: 0;\n  bottom: auto;\n  top: calc(100% + 8px);\n  min-width: 200px;\n  animation: lang-shortcut-inline-in 0.18s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n@keyframes lang-shortcut-inline-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Compact language control beside invite \"Join {club}\" banner */\n.lang-shortcut--invite {\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.lang-shortcut--invite .lang-shortcut__btn {\n  width: auto;\n  min-width: 44px;\n  height: 32px;\n  padding: 0 0.55rem 0 0.4rem;\n  flex-direction: row;\n  gap: 0.28rem;\n  border-radius: 999px;\n  box-shadow: none;\n}\n\n.lang-shortcut--invite .lang-shortcut__btn-flag {\n  font-size: 14px;\n}\n\n.lang-shortcut--invite .lang-shortcut__btn-code {\n  font-size: 10px;\n  margin-top: 0;\n  letter-spacing: 0.04em;\n}\n\n/* Open toward the left so the menu stays on-screen when the control is top-right */\n.lang-shortcut--invite .lang-shortcut__panel {\n  left: auto;\n  right: 0;\n  min-width: 200px;\n  max-width: min(280px, calc(100vw - 1.5rem));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lang-shortcut__btn,\n  .lang-shortcut__option,\n  .lang-shortcut__panel {\n    animation: none;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
